/* eslint-disable */
import DraggableImageContainer from "@/Components/DraggableImageContainer/DraggableImageContainer";
import { Trash2 } from "lucide-react";
import React from "react";

const GroupCreationCard = React.memo(function GroupCreationCard(props) {
    const { item, handleDelete, getContainerList } = props;
    return (
        <div className='p-4 rounded-md bg-white'>
            <div className="flex justify-between items-center w-full py-4">
                <p className="text-lg font-medium text-gray-800">{item?.groupName}</p>
                <div className="flex items-center gap-3">
                    <button
                        className='flex items-center gap-2 bg-gray-200 hover:bg-gray-300 text-black font-medium px-4 py-2 rounded-xl transition'
                        onClick={() => handleDelete(item?.id)}
                    >
                        <Trash2 size={20} />
                        DELETE
                    </button>
                </div>
            </div>
            <div className='h-[200px] sm:h-[250px] md:h-[300px]'>
                <DraggableImageContainer
                    firstContainer={{
                        list: item?.containerList?.firstContainerList,
                        title: `Products NOT IN Group ${item?.groupName}`,
                        showSearchBar: true,
                        placeholder: 'Search Products',
                    }}
                    secondContainer={{
                        list: item?.containerList?.secondContainerList,
                        title: `Products IN Group ${item?.groupName}`,
                        showSearchBar: false,
                        placeholder: 'Search Products',
                    }}
                    getContainersList={(list) => getContainerList(list, item?.id)}
                />
            </div>
        </div>
    )
});

export default GroupCreationCard;